import { createDomain } from 'effector-root';

const domain = createDomain('Breakdown List (Page)');

export const onPageStarted = domain.event();